import { getAttributeNameWithoutPostfix, isCharacterJqueryKeyCode } from '@/core/shared'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'

export function enableMulticheckboxSupport (settings) {

	var SELECTOR = (settings && settings.selector) ? settings.selector : '.multicheckbox-editor'
	var page = $('.page')

	function detectActiveCheckboxList ($multicheckbox) {
		var $checkboxList = $multicheckbox.find('.checkbox-list')
		if ($checkboxList.is(':visible')) {
			return $checkboxList
		} else {
			return $multicheckbox.find('.checkbox-sublist')
		}
	}

	page.on('click', SELECTOR + ' .checkbox-sublist li', function (e) {
		var $editor = $(e.target).closest('li').find('.attribute-editor')
		var $multicheckbox = $(e.target).closest(SELECTOR)
		if ($multicheckbox.hasClass('restraint') && $editor.prop('checked')) {
			$editor.prop('checked', false)
		}
		var $checkboxList = $multicheckbox.find('.checkbox-list')
		var associatedEditor = _.find($checkboxList.find('.attribute-editor'), function (element) {
			return element.value === $editor.val()
		})
		var $associatedItem = $(associatedEditor).closest('li')
		$associatedItem.click()
		$editor.closest('li').attr('class', $associatedItem.attr('class'))
		if (!$(e.target).is('input')) $editor.prop('checked', $(associatedEditor).prop('checked'))
		$editor.focus()
	})

	function update ($activeCheckboxes, attributeName, $valueList) {
		var valuesStr = ''
		$valueList.text('')
		$activeCheckboxes.each(function (index, element) {
			$(element).attr('id', 'list__' + attributeName + '__' + index)
			if ($(element).val()) {
				valuesStr += $(element).parent().text() + ', '
			}
		})
		if (valuesStr.length > 0) $valueList.text(valuesStr.substring(0, valuesStr.length - 1))
	}

	page.on('click', SELECTOR + ' .checkbox-list li', function (e) {
		var $multicheckbox = $(this).closest(SELECTOR)
		var attributeName = getAttributeNameWithoutPostfix($multicheckbox.attr('id'))
		var $valueList = $multicheckbox.find('.value-list')
		var $currentCheckbox = $(this).find('input[type=\'checkbox\']')

		if (!$(e.target).is('input[type=\'checkbox\']')) $currentCheckbox.prop('checked', !$currentCheckbox.prop('checked'))

		var $activeCheckboxes = $(this).closest('.checkbox-list').find('input[type=\'checkbox\']:checked')

		var maxCount = $multicheckbox.attr('max-count')
		if (maxCount > -1 && $currentCheckbox.val()) {
			if ($activeCheckboxes.length === maxCount) {
				$multicheckbox.addClass('restraint')
			} else if ($activeCheckboxes.length > maxCount) {
				$currentCheckbox.prop('checked', false)
				$currentCheckbox.focus()
				return
			} else if ($activeCheckboxes.length === maxCount - 1) {
				$multicheckbox.removeClass('restraint')
			}
		}

		var $clearButton = $multicheckbox.find('.mcb-clear')
		if ($activeCheckboxes.length > 0) {
			$clearButton[0].classList.remove('blank')
		} else {
			$clearButton[0].classList.add('blank')
		}

		if ($currentCheckbox.is(':checked')) {
			$currentCheckbox.parent().addClass('active-item')
		} else {
			$currentCheckbox.removeAttr('id')
			$currentCheckbox.parent().removeClass('active-item')
		}
		if (settings && settings['updateCallback']) {
			settings['updateCallback']($currentCheckbox, settings['userData'])
		} else {
			update($activeCheckboxes, attributeName, $valueList)
		}
		$currentCheckbox.focus()
		attributeChangesRegister(attributeName)
	})

	function multicheckboxToggle (multicheckbox) {
		var $itemList = $(multicheckbox).find('.mcb-item-list').first()
		var attributePosition = $(multicheckbox).find('.mcb-drop-down-btn').get(0).getBoundingClientRect()
		var multicheckboxPosition = $(multicheckbox).find('.mcb-drop-down-btn').offset()
		var top = multicheckboxPosition.top
		var left = multicheckboxPosition.left
		var height = attributePosition.height

		$('.mcb-item-list').each(function () {
			$(this).hide()
		})

		if (!$itemList.is(':visible')) {
			$itemList.show()
			$itemList.offset({top: top + height, left: left })
			var $checkboxList = detectActiveCheckboxList($(multicheckbox))
			var $firstEditor = $checkboxList.find('.attribute-editor').first()
			if ($firstEditor[0]) {
				$firstEditor.focus()
			} else {
				$(multicheckbox).find('.mcb-controls .mcb-search').first().focus()
			}
			$('body').bind('click', multicheckboxOutClick)
			$itemList.trigger('mcb-list-show')
		} else {
			$itemList.hide()
			$('body').unbind('click', multicheckboxOutClick)
			$(multicheckbox).find('.mcb-drop-down-btn').first().focus()
		}

		$(document).scroll(function () {
			$itemList.hide()
		})

		function multicheckboxOutClick (e) {
			if (!$(e.target).hasClass('mcb-drop-down-btn')
				&& !$(e.target).closest('.mcb-item-list')[0]) {
				var $itemList = $('.mcb-item-list:visible')
				if ($itemList.length > 0) {
					$itemList.hide()
					$('body').unbind('click', multicheckboxOutClick)
				}
			}
		}
	}

	page.on('keydown.alt_insert', SELECTOR, function (e) {
		multicheckboxToggle($(e.target).closest(SELECTOR))
	})

	page.on('keydown.tab keydown.esc', SELECTOR + ' .mcb-item-list, ' + SELECTOR + ' .mcb-search', function (e) {
		multicheckboxToggle($(e.target).closest(SELECTOR))
	})

	page.on('click', SELECTOR + ' .mcb-drop-down-btn', function () {
		multicheckboxToggle($(this).closest(SELECTOR))
	})

	page.on('click keydown.return keydown.space', SELECTOR + ' .mcb-clear', function () {
		if (this.classList.contains('blank')) {
			var $multicheckbox = $(this).closest(SELECTOR)
			var $checkboxList = $multicheckbox.find('.checkbox-list')

			var maxCount = $multicheckbox.attr('max-count')
			var count = 0
			$checkboxList.find('input[type=\'checkbox\']').each(function (index, element) {
				count++
				$(element).prop('checked', true).parent().addClass('active-item')
				if (maxCount > -1 && count === maxCount) {
					$multicheckbox.addClass('restraint')
					return false
				}
			})
			var $activeCheckboxes = $checkboxList.find('input[type=\'checkbox\']:checked')
			var attributeName = getAttributeNameWithoutPostfix($multicheckbox.attr('id'))
			update($activeCheckboxes, attributeName, $multicheckbox.find('.value-list'))
			this.classList.remove('blank')
			attributeChangesRegister(attributeName)
			if (settings && settings['selectAllCallback']) settings['selectAllCallback']($checkboxList.attr('data-name'))
		} else if (this.classList.contains('uncertain')) {
			var $multicheckbox = $(this).closest(SELECTOR)
			var $checkboxList = $multicheckbox.find('.checkbox-list')
			var $activeCheckboxes = $checkboxList.find('input[type=\'checkbox\']:checked')
			$activeCheckboxes.each(function (index, element) {
				$(element).removeAttr('id').prop('checked', false).parent().removeClass('active-item')
			})
			if (!$checkboxList.is(':visible')) $multicheckbox.find('.mcb-controls .mcb-search').first().trigger('input')
			if (settings && settings['clearCallback']) settings['clearCallback']($checkboxList.attr('data-name'))
			$multicheckbox.removeClass('restraint').find('.value-list').text('')
			this.classList.remove('uncertain')
			this.classList.add('blank')
			attributeChangesRegister(getAttributeNameWithoutPostfix($multicheckbox.attr('id')))
		} else {
			this.classList.add('uncertain')
		}
		if ($(this).is('input[type=\'checkbox\']')) $(this).prop('checked', false)
	})

	page.on('blur', SELECTOR + ' .mcb-clear', function () {
		if (this.classList.contains('uncertain')) this.classList.remove('uncertain')
	})

	page.on('keydown', SELECTOR + ' .mcb-drop-down-btn, ' + SELECTOR + ' .mcb-item-list', function (e) {
		if (isCharacterJqueryKeyCode(e.which) && (!e.ctrlKey || (e.ctrlKey && e.which === 86)) && !e.altKey) {
			if (!(e.target.classList.contains('mcb-search')) && e.which !== 32) {
				var $multicheckbox = $(this).closest(SELECTOR)
				if (e.target.classList.contains('mcb-drop-down-btn')) multicheckboxToggle($multicheckbox)
				$multicheckbox.find('.mcb-search').first().val('').focus()
			}
		} else if (e.which === 13) {
			if (e.target.classList.contains('mcb-drop-down-btn')) {
				multicheckboxToggle($(this).closest(SELECTOR))
				e.preventDefault()
			} else {
				if ($(e.target).closest('li')[0]) $(e.target).click()
			}
		} else if (e.which === 8 && !(e.target.classList.contains('mcb-search'))) {
			$(this).closest(SELECTOR).find('.mcb-search').first().focus()
		} else if (e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40) {
			if (e.which === 40 && e.target.classList.contains('mcb-search')) {
				var $multicheckbox = $(this).closest(SELECTOR)
				detectActiveCheckboxList($multicheckbox).find('.attribute-editor').first().focus()
				e.preventDefault()
				return
			}
			var $item = $(e.target).closest('li')
			if ($item[0]) {
				var $neighbor = e.which === 38 ? $item.prev() : e.which === 40 ? $item.next() : null
				if ($neighbor && $neighbor.is('li')) {
					$neighbor.find('.attribute-editor').focus()
				} else if (e.which === 38) {
					if (!$item.prev() || !$item.prev().is('li')) {
						$(this).closest('.mcb-item-list').find('.mcb-clear').focus()
					}
				}
				e.preventDefault()
			} else if (e.target.classList.contains('mcb-clear') && e.which === 40) {
				var $multicheckbox = $(this).closest(SELECTOR)
				detectActiveCheckboxList($multicheckbox).find('.attribute-editor').first().focus()
				e.preventDefault()
			}
		}
	})

	page.on('input', SELECTOR + ' .mcb-search', function (e) {
		var $multicheckbox = $(this).closest(SELECTOR)
		var $list = $multicheckbox.find('.checkbox-list')
		var $sublist = $multicheckbox.find('.checkbox-sublist')
		if (!$(e.target).val()) {
			$sublist.html('').hide()
			$list.show()
		} else {
			$list.hide()
			$sublist.html('').show()
			var html = ''
			$list.children('li').each(function (index, element) {
				if (element.textContent.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
					if (!(element.classList.contains('active-item'))) {
						html += element.outerHTML
					} else {
						if (html) {
							$sublist.append(html)
							html = ''
						}
						$sublist.append($(element).clone())
					}
				}
			})
			if (html) $sublist.append(html)
		}
		e.preventDefault()
	})
}

export function disableMulticheckboxSupport (selector) {
	var page = $('.page')
	page.off('click', selector + ' .checkbox-sublist li')
	page.off('click', selector + ' .checkbox-list li')
	page.off('keydown.tab keydown.esc', selector + ' .mcb-item-list, ' + selector + ' .mcb-search')
	page.off('click', selector + ' .mcb-drop-down-btn')
	page.off('click keydown.return keydown.space', selector + ' .mcb-clear')
	page.off('blur', selector + ' .mcb-clear')
	page.off('keydown', selector + ' .mcb-drop-down-btn, ' + selector + ' .mcb-item-list')
	page.off('input', selector + ' .mcb-search')
	page.off('keydown.alt_insert', selector)
}

export function clearMulticheckbox (multicheckbox) {
	var $multicheckbox = $(multicheckbox)
	$multicheckbox.find('.checkbox-list').first().html('').css('display', 'block')
	$multicheckbox.find('.checkbox-sublist').first().html('').css('display', 'none')
	$multicheckbox.find('.mcb-search').first().val('')
}

export function resetMulticheckbox (multicheckbox) {
	var $multicheckbox = $(multicheckbox)
	var $checkboxList = $multicheckbox.find('.checkbox-list')
	var $activeCheckboxes = $checkboxList.find('input[type=\'checkbox\']:checked')
	$activeCheckboxes.each(function (index, element) {
		$(element).removeAttr('id').prop('checked', false).parent().removeClass('active-item')
	})
	if (!$checkboxList.is(':visible')) $multicheckbox.find('.mcb-controls .mcb-search').first().trigger('input')
	$multicheckbox.removeClass('restraint').find('.value-list').text('')
	var $clearControl = $multicheckbox.find('.mcb-clear').first()
	if ($clearControl[0]) {
		if ($clearControl.is('input[type=\'checkbox\']')) $clearControl.prop('checked', false)
		$clearControl[0].classList.remove('uncertain')
	}
	attributeChangesRegister(getAttributeNameWithoutPostfix($multicheckbox.attr("id")));
}
